import cookies from "js-cookie";

const getToken = () => {
    return cookies.get('token')
}

const getLocalRefreshToken = () => {
    return cookies.get('refreshToken')
}

const updateLocalAccessToken = (token) => {
    cookies.set("token", token)
}

const updateLocalRefreshToken = (refreshToken) => {
    cookies.set('refreshToken', refreshToken)
}

const setUser = (token, refreshToken) => {
    cookies.set('token', token)
    cookies.set('refreshToken', refreshToken)
}


const logout = () => {
    cookies.remove("token")
    cookies.remove("refreshToken")
}

const TokenService = {
    getToken,
    getLocalRefreshToken,
    updateLocalAccessToken,
    setUser,
    logout,
    updateLocalRefreshToken,
}

export default TokenService;